import React, { useEffect, useState } from "react";
import {
  getAllGateways,
  getGatewaysList,
  setSelectedGateway,
} from "../../../../redux/user/actions";
import { useDispatch, useSelector } from "react-redux";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import DepositGateway from "./depositGateway";
import { useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import DepositImg from "../../../../assets/images/icons/dc.png";
import bankImg from "../../../../assets/images/icons/bank.png";
import { getActiveBankDetails } from "../../../../redux/app/actions";
import BackIcon from "../../../../assets/svg/BackIcon";
import { Container } from "react-bootstrap";
import { AppLoader } from "../../../components/Ui/AppLoader";
import numberWithCommas from "../../../../utils/numbersWithComma";

const GatewaysList = () => {
  const dispatch = useDispatch();
  const [gatewaysList, setGatewaysList] = useState([]);
  const { bankDetails } = useSelector((state) => state.app);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getActiveBankDetails());
    getAllGatewaysFromServer();
  }, []);

  const getAllGatewaysFromServer = async () => {
    setIsLoading(true);
    const response = await getGatewaysList();
    setIsLoading(false);
    if (response) {
      const list = response?.data?.data?.deposits;
      setGatewaysList(list);
    }
  };

  const handleGatewayClick = (item) => {
    navigate(`/deposit/${item?.id}`);
  };

  const handleBankTransferClick = () => {
    navigate(`/deposit/bank_transfer`);
  };
  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <Container>
          <div className="pagesHeading">
            <h2 className="sectionTitle border-0">Deposit</h2>
            <a className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </a>
          </div>

          <div className="gatewaySection">
            <div className="gatewaypart">
              <Tabs
                defaultActiveKey="Deposit"
                id="uncontrolled-tab-example"
                className="d-none"
              >
                <Tab
                  eventKey="Deposit"
                  title="Online Deposit"
                  className="d-none"
                >
                  {gatewaysList
                    ?.sort((a, b) => a.order - b.order)
                    ?.filter((f) => f.type === "auto")
                    .map((item, index) => {
                      return (
                        <div
                          className="cards1"
                          onClick={() => {
                            handleGatewayClick(item);
                          }}
                          key={index}
                        >
                          <div className="card-icon">
                            <img src={item?.logo || DepositImg} />
                          </div>

                          <p style={{ color: "#333" }}>{item?.name}</p>
                        </div>
                      );
                    })}
                </Tab>
                <Tab eventKey="bank" title="Bank Transfer" className="d-none">
                  {bankDetails && (
                    <div
                      className="cards1"
                      onClick={() => {
                        handleBankTransferClick();
                      }}
                    >
                      {" "}
                      <div className="card-icon">
                        <img src={bankImg} style={{ width: "66px" }} />
                      </div>
                      <p style={{ color: "#333" }}>{"Bank Transfer"}</p>
                    </div>
                  )}

                  {gatewaysList
                    ?.sort((a, b) => a.order - b.order)
                    ?.filter((f) => f.type === "manual")
                    .map((item, index) => {
                      return (
                        <div
                          className="cards1"
                          onClick={() => {
                            handleGatewayClick(item);
                          }}
                          key={index}
                        >
                          <div className="card-icon">
                            <img src={item?.logo || DepositImg} />
                          </div>
                          <p style={{ color: "#333" }}>{item?.name}</p>
                        </div>
                      );
                    })}
                </Tab>
              </Tabs>

              {isLoading ? (
                <AppLoader text="Fetching gateways" />
              ) : (
                <div className="">
                  <div className="DepositSection">
                    <p className="Heading">Online Deposit</p>
                    <div className="GatewaySection">
                      {gatewaysList
                        ?.sort((a, b) => a.order - b.order)
                        ?.filter((f) => f.type === "auto")
                        .map((item, index) => {
                          return (
                            <div
                              className="cards1"
                              onClick={() => {
                                handleGatewayClick(item);
                              }}
                              key={index}
                            >
                              <div className="card-icon">
                                <img src={item?.logo || DepositImg} />
                              </div>

                              <div>
                                <p>{item?.name}</p>

                                {"settings" in item && (
                                  <p style={{ fontSize: "11px" }}>
                                    {numberWithCommas(item?.settings?.min)} -{" "}
                                    {numberWithCommas(item?.settings?.max)}
                                  </p>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  <div className="DepositSection">
                    <p className="Heading">Bank Transfer</p>
                    <div className="GatewaySection">
                      {bankDetails && (
                        <div
                          className="cards1"
                          onClick={() => {
                            handleBankTransferClick();
                          }}
                        >
                          {" "}
                          <div className="card-icon">
                            <img src={bankImg} style={{ width: "66px" }} />
                          </div>
                          <p>{"Bank Transfer"}</p>
                        </div>
                      )}

                      {gatewaysList
                        ?.sort((a, b) => a.order - b.order)
                        ?.filter((f) => f.type === "manual")
                        .map((item, index) => {
                          return (
                            <div
                              className="cards1"
                              onClick={() => {
                                handleGatewayClick(item);
                              }}
                              key={index}
                            >
                              <div className="card-icon">
                                <img src={item?.logo || DepositImg} />
                              </div>
                              <div>
                                <p>{item?.name}</p>

                                {"settings" in item && (
                                  <p style={{ fontSize: "11px" }}>
                                    {numberWithCommas(item?.settings?.min)} -{" "}
                                    {numberWithCommas(item?.settings?.max)}
                                  </p>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Container>
      </main>
    </>
  );
};
export default GatewaysList;
